<script>
import transparenciaServico from '../../../servico';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import CabecalhoRelatorio from '../CabecalhoRelatorio.vue';


export default {
    components: { CabecalhoRelatorio },
    data() {
        return {
            filtroPagamento: '',
            pagamentos: [],
            carregando: false,
            total: 0,
            tipoFiltro: [{ id: 1, text: 'CPF' }, { id: 2, text: 'CNPJ' }, { id: 3, text: 'Nome' }],
            idTipoFiltro: '3',
            habilitaFiltroCpf: false,
            habilitaFiltroCnpj: false,
            habilitaFiltragem: false,
        }
    },
    methods: {
        exportarExcel() {
            const data = [
                ["Relatório de Verificação de Pagamento"],
                [],
                ["Data: ", this.$options.filters.formatarData(new Date())],
                [],
                [`Total: ${this.pagamentos.length} registro(s)`],
                [],
                ["Projeto", "Data", "Dados do pagamento", "CPF/CNPJ", "Valor líquido (R$)"],
                [],
            ];

            this.pagamentos.forEach(item => {
                data.push([
                    item.nomeProjeto || '---',
                    this.$options.filters.formatarData(item.data),
                    (item.historico + " - " + item.formaPagamento + " - " + item.complemento) || '---',
                    item.cpfcnpj || '---',
                    this.$options.filters.formatarNumero(item.valor),
                ]);
            });

            data.push([])
            data.push(["", "", "", "Total: ", this.$options.filters.formatarNumero(this.total)]);

            const ws = XLSX.utils.aoa_to_sheet(data);

            const nomeArquivo = "verificacao_pagamento";

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, nomeArquivo);

            const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
            saveAs(new Blob([wbout], { type: "application/octet-stream" }), `${nomeArquivo}.xlsx`);

        },
        imprimirPagina() {
            window.print();
        },
        async lista() {
            try {
                this.carregando = true;
                await transparenciaServico
                    .institucionalPagamentos(this.filtroPagamento, this.idTipoFiltro)
                    .then(institucionalPagamentos => {
                        this.pagamentos = institucionalPagamentos;
                    });

                this.total = this.getTotal()
            } catch (error) {
                this.pagamentos = []
                if(error.body.mensagem){
                    this.$swal('', error.body.mensagem , 'error');
                }else{
                    this.$swal('', 'Ocorreu um erro ao carregar os dados, tente novamente.', 'error');
                }
            } finally {
                this.carregando = false;
            }
        },
        getTotal() {
            let total = 0;
            this.pagamentos.forEach(item => {
                total += item.valor;
            });
            return total;
        },
        placeholderFiltro() {
            switch (this.idTipoFiltro) {
                case 1:
                    return 'Digite o CPF';
                case 2:
                    return 'Digite o CNPJ';
                default:
                    return 'Digite o nome';
            }
        },
        aplicarMascara(event) {
            let valor = event.target.value;

            if (this.idTipoFiltro === 1) {
                valor = valor.replace(/\D/g, '');
                valor = valor.slice(0, 11);
                valor = valor
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d{1,2})$/, '$1-$2');

            } else if (this.idTipoFiltro === 2) {
                valor = valor.replace(/\D/g, '');
                valor = valor.slice(0, 14);
                valor = valor
                    .replace(/^(\d{2})(\d)/, '$1.$2')
                    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
                    .replace(/\.(\d{3})(\d)/, '.$1/$2')
                    .replace(/(\d{4})(\d)/, '$1-$2');

            }
            this.filtroPagamento = valor;
        },
        desabilitaFiltragem(value){
            switch (this.idTipoFiltro) {
                case 1:
                    this.habilitaFiltroCnpj = true;
                    this.habilitaFiltroCpf = value.length == 14;
                    break
                case 2:
                    this.habilitaFiltroCnpj = value.length == 18;
                    this.habilitaFiltroCpf = true;
                    break
                default:
                    this.habilitaFiltroCnpj = true;
                    this.habilitaFiltroCpf = true;
            }
            this.habilitaFiltragem =  !this.carregando && this.filtroPagamento.length >= 3 && this.habilitaFiltroCpf &&  this.habilitaFiltroCnpj
        }
    },
    computed: {
    },
    mounted() {
    },
    watch: {
        idTipoFiltro(newValue) {
            this.filtroPagamento = '';
            this.placeholderFiltro();
            
        },
        filtroPagamento(newValue) {
            this.desabilitaFiltragem(newValue)
        }
    }
}
</script>

<template>
    <div>
        <div class="ibox float-e-margins">
            <div class="ibox-title hidden-print">
                <div class="row">
                    <div class="col-md-10 flex-container " style="justify-content:start; padding-left:15px">
                        <h3><b>Institucional - Verificação de Pagamento</b></h3>
                    </div>

                    <div class="col-md-2 flex-container" style="justify-content:end; gap:10px">

                        <button class="btn btn-primary" @click="exportarExcel">
                            <i class="fa fa-file-excel-o"></i> Excel
                        </button>

                        <button class="btn btn-primary" @click="imprimirPagina">
                            <i class="fa fa-file-pdf-o"></i> PDF
                        </button>

                    </div>
                </div>
            </div>

            <div class="ibox-content">

                <div class="row hidden-print">

                    <div class="col-lg-12">
                        <label class="control-label">Filtrar por:</label>
                    </div>

                    <div class="col-lg-2">
                        <div class="form-group">
                            <select id="tipo-filtro" class="form-control" v-model="idTipoFiltro">
                                <option :value="filtro.id" v-for="(filtro, index) in tipoFiltro">
                                    {{ filtro.text }}
                                </option>
                            </select>
                        </div>
                    </div>

                    <div class="col-lg-6">
                        <div class="form-group">
                            <input type="text" class="form-control" id="filtro-pagamento" v-model="filtroPagamento"
                                :placeholder="placeholderFiltro()" @input="aplicarMascara">
                        </div>
                    </div>

                </div>

                <div class="row hidden-print">
                    <div class="col-lg-12">

                        <button class="btn btn-primary" type="button" @click="lista()"
                            :disabled="!habilitaFiltragem">
                            <i class="fa fa-search"></i> Filtrar
                        </button>

                    </div>
                </div>

                <cabecalho-relatorio titulo="Institucional" nomeProjeto="Relatório de verificação de pagamento"
                    borda=""></cabecalho-relatorio>

                <div class="padding-5"></div>

                <div class="row text-right padding-20" v-if="!carregando">
                    Total: {{ this.pagamentos.length }} registro(s)
                </div>

                <div class="table-responsive">

                    <table class="table table-bordered table-hover table-striped pointer relatorio">
                        <thead>
                            <tr>
                                <th>Projeto</th>
                                <th>Data</th>
                                <th>Dados do pagamento</th>
                                <th>CPF/CNPJ</th>
                                <th class="text-right">Valor líquido&nbsp;(R$)</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="pagamentos.length > 0 && !carregando" v-for="pagamento in pagamentos">
                                <td>{{ pagamento.nomeProjeto }}</td>
                                <td>{{ pagamento.data | formatarData('---') }}</td>
                                <td>{{ pagamento.historico + "\n" + pagamento.formaPagamento + " - " +
                                    pagamento.complemento || '---' }}</td>
                                <td>{{ pagamento.cpfcnpj || '---' }}</td>
                                <td class="text-right">{{ pagamento.valor | formatarNumero }}</td>
                            </tr>

                            <tr v-if="!carregando && pagamentos.length > 0">
                                <td colspan="4" class="text-right">
                                    <span>{{ "Total:" }}</span>
                                </td>
                                <td colspan="1" class="text-right" style="font-weight: bold;">
                                    <span>{{ total | formatarNumero }}</span>
                                </td>
                            </tr>

                            <tr v-show="carregando">
                                <td colspan="5" class="text-center">
                                    <i class='fa fa-spinner fa-pulse'></i> Carregando...
                                </td>
                            </tr>

                            <tr v-if="!carregando && pagamentos.length === 0">
                                <td colspan="5" class="text-center">Não há dados.</td>
                            </tr>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/transparencia/componentes/compartilhado/institucional/InstitucionalDetalhar.vue